/* jshint esnext: true */

/**
 * Shuffle an array.
 *
 * @param {array} a List of items to shuffle.
 */
const shuffle = ( a ) => {

	for ( let i = a.length - 1; i > 0; i-- ) {
		const j = Math.floor( rando.gen() * ( i + 1 ) );
		[ a[ i ], a[ j ] ] = [ a[ j ], a[ i ] ];
	}

	return a;

};


/**
 * Execute a function on dom ready.
 *
 * @param {function} callback Function to execute on load.
 */
const domReady = ( callback ) => {

	document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener( "DOMContentLoaded", callback );

};


/**
 *
 */
const get_game_size = () => {

	let game_width_ratio = window.innerWidth;
	let game_height_ratio = window.innerHeight;

	let game_width = 256;
	let game_height = ( game_width / game_width_ratio ) * game_height_ratio;

	return {
		width: game_width,
		height: game_height
	};

};


const resize_game = () => {

	let game_size = get_game_size();
	game.scale.resize( game_size.width, game_size.height );
	game.scale.setGameSize( game_size.width, game_size.height );

	// console.log( mazes.currentMaze.layer.getBounds() );

};